import { render, staticRenderFns } from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=template&id=efa88b14&"
import script from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=script&lang=js&"
export * from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports